enum NoteStatus {
    OPEN = "open",
    RESOLVED = "resolved"
}

export default NoteStatus;
